type Params = {
  description: string;
  target: string;
};

export const createSchemaDownloadAction = ({
  description,
  target,
}: Params) => (
  {
    '@context': 'https://schema.org',
    '@type': 'DownloadAction',
    description: `${description}`,
    target: `${target}`,
  }
);
